export default "__VITE_ASSET__n3Z1y0HL__"